import { http } from "@/providers/http";
export class NotAcceptedEmailApi {
  private static INSTANCE = new NotAcceptedEmailApi();

  static get instance() {
    return this.INSTANCE;
  }

  public sendEmailData(emailData: FormData) {
    const endpoint = "cfss/email";
    const headers = {
      ...http.getTokenHeaders(),
      "Content-Type": "multipart/form-data",
    };
    return http.post(endpoint, headers, emailData, true).then((response) => {
      return response;
    });
  }

  public getEmailHistory(applicationId: any) {
    const endpoint = `cfss/email?applicationId=${applicationId}`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response;
    });
  }

  /**
   * Unread summary for the signed-in reviewer, used by the notification bell.
   *
   * Returns one row per thread - not per mail - each carrying its own
   * unreadCount and the latest sender, subject and date, alongside a
   * totalUnreadCount for the whole feed. Resolves to an empty list on failure
   * so the bell renders its empty state instead of surfacing an error.
   */
  public getUnreadMails() {
    const endpoint = `cfss/email/unread`;
    const headers = http.getTokenHeaders();
    return http
      .get(endpoint, headers)
      .then((response: any) => {
        const payload = response?.data ?? response;
        return payload?.data ?? [];
      })
      .catch(() => {
        return [];
      });
  }

  /**
   * Mark a thread read. `query` is a complete `key=value` pair for the same
   * three scopes the history accepts (applicationId, userId or email), so the
   * caller states which key this mail is actually keyed on.
   *
   * Called only when the reviewer opens a notification, replies, or clears it
   * -- never on the polling fetch, which would mark mail read without it being
   * seen. Swallows failure so the panel's own state stays authoritative.
   */
  public markEmailRead(query: string) {
    const endpoint = `cfss/email/read?${query}`;
    const headers = http.getTokenHeaders();
    return http
      .put(endpoint, headers)
      .then((response: any) => {
        return response;
      })
      .catch(() => {
        return null;
      });
  }
}

export const notAcceptedEmailApi = NotAcceptedEmailApi.instance;
